import { CircleCheck, CircleX } from 'lucide-react';
import { MouseEvent, useState } from 'react';
import LangEnum from '../../../../../../../lang/LangEnum';
import { useUpdateCatalog } from '../../../../../../../services/modules/catalogs/catalogs.mutations';
import snackbarStore from '../../../../../../../stores/Snackbar.store';
import { useTranslation } from '../../../../../../translation/TranslationContext';

interface UseCatalogMoreActionsButtonParams {
  catalogId: string;
  isCatalogActive?: boolean;
}

const useCatalogMoreActionsButton = ({
  catalogId,
  isCatalogActive,
}: UseCatalogMoreActionsButtonParams) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const { translate } = useTranslation();
  const { isPending, mutate } = useUpdateCatalog({ catalogId });

  const openMenu = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorEl(null);
  };

  const notifyStatusChange = () => {
    snackbarStore.handleMessage({
      type: 'success',
      message: translate(
        isCatalogActive
          ? LangEnum.CATALOGS_STATUS_INACTIVATED_SUCCESS
          : LangEnum.CATALOGS_STATUS_ACTIVATED_SUCCESS,
      ),
    });
  };

  const toggleStatus = () => {
    mutate({ active: !isCatalogActive }, { onSuccess: notifyStatusChange });
    closeMenu();
  };

  return {
    anchorEl,
    isOpen: Boolean(anchorEl),
    isPending,
    statusActionLabel: isCatalogActive ? LangEnum.GLOBAL_INACTIVATE : LangEnum.GLOBAL_ACTIVATE,
    statusActionIcon: isCatalogActive ? CircleX : CircleCheck,
    openMenu,
    closeMenu,
    toggleStatus,
  };
};

export default useCatalogMoreActionsButton;
